import type { ReactNode } from "react";

import { Navigate, useLocation } from "react-router";

import { PATHS } from "@/app/routes/paths";
import { SsoRedirect } from "@/features/auth/SsoRedirect";
import { SSO_REQUESTED } from "@/core/sso/irwms";
import { useAuth } from "@/shared/contexts/AuthContext";

/**
 * Route guard: unauthenticated users are redirected to the login page,
 * preserving the requested location for post-login redirect.
 * Permission-level guards are added once the RSM RBAC integration lands.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // With IRWMS configured, the identity provider is the login page: a person
    // with a live SSO session comes straight back signed in, with no prompt.
    if (SSO_REQUESTED) {
      return <SsoRedirect returnTo={location.pathname + location.search} />;
    }
    return <Navigate to={PATHS.auth.login} replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
